const REACT_APP_API_URL= process.env.REACT_APP_API_URL
const REACT_APP_AZURE_CLIENT_ID=process.env.REACT_APP_AZURE_CLIENT_ID
const REACT_APP_AZURE_TENANT_ID=process.env.REACT_APP_AZURE_TENANT_ID

export default {
    REACT_APP_API_URL,
    REACT_APP_AZURE_CLIENT_ID,
    REACT_APP_AZURE_TENANT_ID
}